import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "content-header" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row mb-2" }
const _hoisted_4 = { class: "col-sm-6" }
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "breadcrumb float-sm-right" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Home")
], -1)
const _hoisted_8 = { class: "breadcrumb-item active" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "container-fluid" }
const _hoisted_11 = { class: "card" }
const _hoisted_12 = { class: "card-header" }
const _hoisted_13 = { class: "card-title" }
const _hoisted_14 = { class: "form-row" }
const _hoisted_15 = { class: "form-group col-12 col-sm-6" }
const _hoisted_16 = { for: "name" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { class: "form-group col-12 col-sm-6" }
const _hoisted_19 = { for: "payment" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { class: "form-row" }
const _hoisted_22 = { class: "form-group col-12 col-sm-6" }
const _hoisted_23 = { for: "price" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = { class: "form-row" }
const _hoisted_26 = { class: "form-group col-5" }
const _hoisted_27 = {
  class: "form-group col-2",
  style: {"text-align":"center"}
}
const _hoisted_28 = { class: "form-group col-5" }
const _hoisted_29 = { class: "form-group col-sm-6" }
const _hoisted_30 = { for: "status" }
const _hoisted_31 = { value: "Confirmed" }
const _hoisted_32 = { value: "PendingPayment" }
const _hoisted_33 = { value: "AwaitingPaymentConfirmation" }
const _hoisted_34 = { value: "FailedPayment" }
const _hoisted_35 = { value: "Canceled" }
const _hoisted_36 = { class: "card-tools" }
const _hoisted_37 = { class: "card-tools" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-redo",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = { class: "card-body table-body" }
const _hoisted_41 = {
  class: "table-button-container",
  style: {"text-align":"center"}
}
const _hoisted_42 = { class: "btn-group" }
const _hoisted_43 = ["onClick", "title"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye" }, null, -1)
const _hoisted_45 = [
  _hoisted_44
]

export function render(_ctx, _cache) {
  const _component_table_lite = _resolveComponent("table-lite")
  const _directive_maska = _resolveDirective("maska")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t("labels.page.order")), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ol", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("li", _hoisted_8, _toDisplayString(_ctx.$t("labels.page.order")), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h3", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("labels.entity.name")), 1),
                  _hoisted_17,
                  _withDirectives(_createElementVNode("input", {
                    id: "name",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.filterOrder.name) = $event)),
                    type: "text",
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.filterOrder.name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("labels.entity.payment")), 1),
                  _hoisted_20,
                  _withDirectives(_createElementVNode("input", {
                    id: "payment",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.filterOrder.payment) = $event)),
                    type: "text",
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.filterOrder.payment]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t("labels.entity.date")), 1),
                  _hoisted_24,
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _withDirectives(_createElementVNode("input", {
                        id: "dateIni",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.filterOrder.dateIni) = $event)),
                        type: "text",
                        class: "form-control",
                        "data-maska": "##/##/####",
                        placeholder: "dd/mm/yyyy"
                      }, null, 512), [
                        [_vModelText, _ctx.filterOrder.dateIni],
                        [_directive_maska]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t("labels.to")), 1),
                    _createElementVNode("div", _hoisted_28, [
                      _withDirectives(_createElementVNode("input", {
                        id: "dateIni",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.filterOrder.dateEnd) = $event)),
                        type: "text",
                        class: "form-control",
                        "data-maska": "##/##/####",
                        placeholder: "dd/mm/yyyy"
                      }, null, 512), [
                        [_vModelText, _ctx.filterOrder.dateEnd],
                        [_directive_maska]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t("labels.entity.status")), 1),
                  _withDirectives(_createElementVNode("select", {
                    id: "status",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.filterOrder.status) = $event)),
                    style: {"width":"auto","max-width":"-webkit-fill-available"},
                    class: "form-control"
                  }, [
                    _createElementVNode("option", _hoisted_31, _toDisplayString(_ctx.$t('labels.order.status.confirmed')), 1),
                    _createElementVNode("option", _hoisted_32, _toDisplayString(_ctx.$t('labels.order.status.pendingPayment')), 1),
                    _createElementVNode("option", _hoisted_33, _toDisplayString(_ctx.$t('labels.order.status.awaitingPaymentConfirmation')), 1),
                    _createElementVNode("option", _hoisted_34, _toDisplayString(_ctx.$t('labels.order.status.failedPayment')), 1),
                    _createElementVNode("option", _hoisted_35, _toDisplayString(_ctx.$t('labels.order.status.canceled')), 1)
                  ], 512), [
                    [_vModelSelect, _ctx.filterOrder.status]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-info",
                  onClick: _cache[5] || (_cache[5] = (...args) => (_ctx.doFilter && _ctx.doFilter(...args)))
                }, _toDisplayString(_ctx.$t('labels.search')), 1),
                _createTextVNode("   "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-default",
                  onClick: _cache[6] || (_cache[6] = (...args) => (_ctx.clear && _ctx.clear(...args)))
                }, _toDisplayString(_ctx.$t('labels.buttons.clean')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("button", {
                id: "newButton",
                class: "btn btn-sm btn-default btn-new",
                onClick: _cache[7] || (_cache[7] = $event => (_ctx.reload())),
                style: {"width":"33px"},
                "data-tooltip": "Atualizar"
              }, _hoisted_39)
            ])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createVNode(_component_table_lite, {
              "is-slot-mode": true,
              "is-loading": _ctx.table.isLoading,
              columns: _ctx.table.columns,
              rows: _ctx.table.rows,
              total: _ctx.table.totalRecordCount,
              sortable: _ctx.table.sortable,
              messages: _ctx.table.messages,
              onDoSearch: _ctx.doSearch,
              onIsFinished: _cache[8] || (_cache[8] = $event => (_ctx.table.isLoading = false))
            }, {
              "customer.name": _withCtx((props) => [
                _createTextVNode(_toDisplayString(props.value.customer ? props.value.customer.name : '-'), 1)
              ]),
              expire_in: _withCtx((props) => [
                _createTextVNode(_toDisplayString(props.value.expire_in ? _ctx.formatDate(props.value.expire_in) : '-'), 1)
              ]),
              createdAt: _withCtx((props) => [
                _createTextVNode(_toDisplayString(props.value.createdAt ? _ctx.formatDate(props.value.createdAt) : '-'), 1)
              ]),
              "payment.transaction_code": _withCtx((props) => [
                _createTextVNode(_toDisplayString(props.value.payment ? props.value.payment.transaction_code : '-'), 1)
              ]),
              amount: _withCtx((props) => [
                _createTextVNode(_toDisplayString(_ctx.formatNumber(props.value.amount)) + "  ", 1)
              ]),
              status: _withCtx((props) => [
                _createElementVNode("span", {
                  class: _normalizeClass(["badge", {
              'bg-success': props.value.status === 'Confirmed',
              'bg-info': props.value.status === 'PendingPayment',
              'bg-primary': props.value.status === 'AwaitingPaymentConfirmation',
              'bg-warning': props.value.status === 'FailedPayment',
              'bg-danger': props.value.status === 'Canceled'
            }]),
                  style: {"text-wrap":"wrap"}
                }, _toDisplayString(_ctx.$t(`labels.order.status.${props.value.status.charAt(0).toLowerCase() + props.value.status.slice(1)}`)), 3)
              ]),
              actions: _withCtx((props) => [
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    (_ctx.hasPermission('read'))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          onClick: $event => (_ctx.view(props.value.id)),
                          class: "btn btn-xs btn-success",
                          "data-delay": "500",
                          "data-hasqtip": "0",
                          "aria-describedby": "qtip-0",
                          title: _ctx.$t('labels.buttons.view')
                        }, _hoisted_45, 8, _hoisted_43))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["is-loading", "columns", "rows", "total", "sortable", "messages", "onDoSearch"])
          ])
        ])
      ])
    ])
  ], 64))
}